import React from "react";
import { Card, useAccordionButton } from "react-bootstrap";

export type PastInfoAccordionToggle = {
	eventKey: string;
	children: React.ReactElement | React.ReactElement[];
	onClick?: () => void;
};
export const PastInfoAccordionToggle = React.memo((props: PastInfoAccordionToggle) => {
	const { eventKey, children, onClick } = props;
	const decoratedOnClick = useAccordionButton(eventKey, () => {
		onClick();
	});
	return (
		<Card.Header className="bg-white border-0" onClick={decoratedOnClick} style={{ cursor: "pointer" }}>
			{children}
		</Card.Header>
	);
});
